module.exports = __webpack_public_path__ + "static/media/ju-88.c5ea910c.jpg";